export default __webpack_public_path__ + "file/Fiche-FR-Produit-Puroak-Stave-24.asset.ecd4cd62.pdf";